module.exports = __webpack_public_path__ + "img/hummus-vegetale.424719ad.png";